"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextSkeleton = exports.Root = exports.RadioSkeleton = exports.PickupPointsSkeletonRoot = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(3),
  paddingTop: theme.spacing(3),
  '&:not(:last-child)': {
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    paddingBottom: theme.spacing(3)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1)
}));
const TextSkeleton = exports.TextSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  borderRadius: theme.spacing(1)
}));
const PickupPointsSkeletonRoot = exports.PickupPointsSkeletonRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column'
}));
const RadioSkeleton = exports.RadioSkeleton = (0, _mui.styled)(_mui.Skeleton)(({
  theme
}) => ({
  marginTop: theme.spacing(6.4)
}));